import { PORT, PROTOCOL } from '@constants';

export const baseUrlBuilder = (domain: string) =>
  `${PROTOCOL}://${domain}:${PORT}/api`;
